import { TableCell, styled, useTheme } from "@mui/material"
import { formatNumber } from "@pharmupp/p3-front-commons"
import { StrikeThroughChip } from "@pharmupp/p3-front-commons"
import {
  type ApiListAdhMarketingOperation,
  OperationStateEnum,
} from "../../AdherentMarketingOperations"
import { StatusChip } from "../../commons"

type PointsCellProps = Pick<
  ApiListAdhMarketingOperation,
  "nbLoyaltyPoints" | "hidden"
> & {
  state: ApiListAdhMarketingOperation["state"] | (string & {})
}

const MissedBonus = ({ bonus }: { bonus: number }) => {
  const {
    palette: {
      common: { cloudGray },
    },
  } = useTheme()
  return (
    <StrikeThroughChip
      color={cloudGray}
      isStrikethrough
      size="tiny"
      label={`${formatNumber(bonus)} pts`}
    />
  )
}

const TinyStatusChip = styled(StatusChip)({})
TinyStatusChip.defaultProps = {
  size: "tiny",
  withDarkBorder: true,
}

const Points = ({ state, nbLoyaltyPoints, hidden }: PointsCellProps) => {
  const {
    palette: { common, success },
  } = useTheme()
  if (hidden) return <MissedBonus bonus={nbLoyaltyPoints || 0} />
  switch (state) {
    case OperationStateEnum.EXPIRED:
    case OperationStateEnum.OUTDATED:
    case OperationStateEnum.REJECTED:
      return <MissedBonus bonus={nbLoyaltyPoints || 0} />
    case OperationStateEnum.VALIDATED:
      return (
        <TinyStatusChip
          color={success.main}
          label={`${formatNumber(nbLoyaltyPoints || 0, { signDisplay: "exceptZero" })} pts`}
        />
      )
    default:
      return (
        <TinyStatusChip
          color={common.electricBlue}
          label={`${formatNumber(nbLoyaltyPoints || 0)} pts`}
        />
      )
  }
}

export const PointsCell = (props: PointsCellProps) => (
  <TableCell>
    <Points {...props} />
  </TableCell>
)
